import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

export type RequireDatasourceContext = 'filter' | 'visual';

interface RequireDatasourceCopy {
  headerTitle: string;
  headerSubtitle: string;
  cardDescription: string;
}

@Component({
    selector: 'app-require-datasource-modal',
    templateUrl: './require-datasource-modal.component.html',
    styleUrl: './require-datasource-modal.component.scss',
    imports: [MatIcon]
})
export class RequireDatasourceModalComponent {
  @Input() context: RequireDatasourceContext = 'filter';

  @Output() selectDataSource = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  private readonly copy: Record<RequireDatasourceContext, RequireDatasourceCopy> = {
    filter: {
      headerTitle: 'Add filter',
      headerSubtitle: 'Describe the filter you need and generate a ready-to-review configuration.',
      cardDescription: 'Choose a data source so you can create filters for your report. Once it\u2019s connected, you\u2019ll be able to build and review your filter configuration.'
    },
    visual: {
      headerTitle: 'Add visual',
      headerSubtitle: 'Describe the visual you need and generate a ready-to-review configuration.',
      cardDescription: 'Choose a data source so you can create visuals for your report. Once it\u2019s connected, you\u2019ll be able to build and review your visual configuration.'
    }
  };

  get headerTitle(): string {
    return this.copy[this.context].headerTitle;
  }

  get headerSubtitle(): string {
    return this.copy[this.context].headerSubtitle;
  }

  get cardDescription(): string {
    return this.copy[this.context].cardDescription;
  }

  onSelectDataSource(): void {
    this.selectDataSource.emit();
  }

  onCancel(): void {
    this.cancelled.emit();
  }
}
